import LogoAiraStar from "../../../assets/img/logo-mjv-aira-star.svg";
import { useNavigate } from "react-router-dom";
import { useKeycloak } from "@react-keycloak/web";
import { FaSignOutAlt } from "react-icons/fa";
import DynamicBreadcrumb from "../../Molecules/DynamicBreadcrumb";

export default function Header() {
    const navigate = useNavigate();
    const { keycloak } = useKeycloak();
    const userRoles = keycloak.tokenParsed?.realm_access.roles;
    const isProcessUser = userRoles.includes('mjv-user');

    const handleLogout = async (e) => {
        e.preventDefault();
        try {
          await keycloak.logout();
        } catch (err) {
          console.error(err);
        }
      };

    return (
        <div className="mx-3 my-2 d-flex flex-row align-items-center justify-content-between">
            <div className="d-flex flex-row align-items-center gap-2">
                <button className="btn" onClick={() => navigate(isProcessUser ? "/projects" : "/")}>
                    <img src={LogoAiraStar} alt="Logo Aira Star" />
                </button>
                <DynamicBreadcrumb />
            </div>
            <button className="btn" onClick={handleLogout}>
                <FaSignOutAlt />
            </button>
        </div>
    )
}
